import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default class MapUnits {
    constructor() {
        this.section = document.querySelector('.components-blocks-map-units');
        // this.key = '73bf1162-eaa4-4d46-bece-18a3bb07ba7c';

        this.ready();
    }

    ready() {
        var myIcon = L.icon({
            iconUrl: '/images/components/map-units/pin.png',
            iconSize: [24, 30],
            iconAnchor: [6, 22],
            popupAnchor: [-3, -76],
            shadowUrl: '',
            shadowSize: [0, 0],
            shadowAnchor: [0, 0],
        });

        var map = L.map('mapcmaa').setView([-18.8665378, -45.6960063], 5);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 5,
        }).addTo(map);
        document.querySelector('.leaflet-control-container').style.visibility = 'hidden';

        if (locations) {
            for (var i = 0; i < locations.length; i++) {
                var marker = L.marker([Number(locations[i].lat), Number(locations[i].lng)], { icon: myIcon }).addTo(
                    map
                );
                marker.on('click', this.markerClick.bind(this, locations[i]));
            }
        }

        map.dragging.disable();
        map.touchZoom.disable();
        map.doubleClickZoom.disable();
        map.scrollWheelZoom.disable();
        map.boxZoom.disable();
        map.keyboard.disable();
        if (map.tap) map.tap.disable();
        document.getElementById('mapcmaa').style.cursor = 'default';
    }

    markerClick(location) {
        const points = this.section.querySelectorAll('.point');
        points.forEach((point) => {
            point.classList.remove('active');
        });
        this.section.querySelector('.' + location.point).classList.add('active');
        if (document.body.clientWidth < 1000) {
            document
                .querySelector('.components-blocks-map-units .modals-points')
                .scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}

if (document.querySelector('.components-blocks-map-units')) {
    new MapUnits();
}
